import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.emisores.list = {
      ...state.app.emisores.list,
      ...data,
    };
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.emisores.list = {
      ...state.app.emisores.list,
      filters: {
        ...state.app.emisores.list.filters,
        ...meta,
      },
      pagination: {
        ...state.app.emisores.list.pagination,
        limit: meta.limit ?? 25,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.emisores.list;

    const params = {
      ...filters,
      ...meta,
      include: 'nomina',
      limit: pagination.limit,
    };

    const response = await Http.get('api/emisores', { params });

    store.setState((state) => {
      state.app.emisores.list = {
        ...state.app.emisores.list,
        data: response.data,
        pagination: {
          ...state.app.emisores.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
        busy: false,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.list.busy = false;
      state.app.emisores.list.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.list = { ...initialState };
  });
};

const EmisorListStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    paginate,
    reset,
  },
};

export default EmisorListStore;
